import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { login } from '../../services/authService';
import logger from '../../services/logger';
import { useSiteSettings } from '../../../siteSettings';
import AdminToast from '../../components/AdminToast';
import '../../styles/admin.css';
import '../../styles/admin-theme-overrides.css';

const AdminLogin = () => {
  const history = useHistory();
  const location = useLocation();
  const [identifier, setIdentifier] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  const settings = useSiteSettings();

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(identifier, password);
      const destination = location.state && location.state.from ? location.state.from.pathname : '/admin/dashboard';
      history.replace(destination);
    } catch (requestError) {
      setError(requestError.message);
      logger.error('Admin login failed', { requestId: requestError.requestId, status: requestError.status });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-decoration admin-login-decoration-one" />
      <div className="admin-login-decoration admin-login-decoration-two" />
      <div className="admin-login-card">
        <div className="admin-login-brand"><span className="admin-login-couple-name">{settings.coupleNames}</span></div>
        <div className="admin-page-heading">
          <span className="admin-eyebrow">BIENVENUE</span>
          <h1>Connexion</h1>
          <p>Accédez à votre espace de gestion.</p>
        </div>
        <AdminToast message={error} type="danger" onClose={() => setError('')} />
        <form onSubmit={submit}>
          <label className="admin-form-label" htmlFor="admin-identifier">Identifiant ou e-mail</label>
          <input id="admin-identifier" className="admin-form-control" type="text" value={identifier} onChange={(event) => setIdentifier(event.target.value)} autoComplete="username" required />
          <label className="admin-form-label" htmlFor="admin-password">Mot de passe</label>
          <input id="admin-password" className="admin-form-control" type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" required />
          <button className="admin-button admin-button-primary admin-login-submit" type="submit" disabled={loading}>
            {loading ? 'Connexion…' : 'Se connecter'} <i className="fa fa-arrow-right" aria-hidden="true" />
          </button>
        </form>
        <a className="admin-back-link" href="/">← Retour au site</a>
      </div>
    </div>
  );
};

export default AdminLogin;
